export const toUTCTimeStamp = (date: string, isEndOfDay?: boolean) => {
  const utcDateStr = isEndOfDay ? `${date}T23:59:59` : `${date}T00:00:00`;
  return utcDateStr;
};
